var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tab-menu"},[_c('Menu',{attrs:{"variant":"tabs","items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }